import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { mediaBreakpointDown } from '../../utils/styling';
import { trackCustomEvent } from "gatsby-plugin-google-analytics";
import aiIcon from "../../images/ai_cta_icon.svg";


const PostCTA = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-size: 132px auto;
	box-shadow: 0 8px 30px rgba(50, 75, 93, 0.1), 0 4px 20px rgba(63, 52, 146, 0.02);
	transition: all 0.3s ease-in-out 0s;
	z-index: 99;
	visibility: hidden;
	opacity: 0;
	background: #fff;

	${(props) =>
		props.show &&
		`
			visibility: visible;
			opacity: 1;
			z-index: 9999;
  		`}
`;
const PostCTAContent = styled.div`
	padding: 25px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	max-width: 1316px;
	margin: 0 auto;

	> div > h2 {
		font-size: 20px;
		color: #2b3477;
		margin: 0;
	}

	> div > p {
		margin: 5px 0 0 0;
		display:flex;
		align-items:center;
		font-size: 14px;

		> img {
			margin-right: 5px;
		}
	}

	${mediaBreakpointDown('xs')} {
		// flex-direction: column;
		padding: 20px 20px;

		> h2 {
			margin: 0 0 10px 0;
		}
	}
`;

const HeroButton = styled.button`
	font-size: 16px;
	padding: 20px 32px;
	border-radius: 8px;
	color: #fff;
	background-color: #e01efe;
	border: 1px solid #e01efe;
	transition: all 0.3s ease-in-out 0s;
	line-height: 1em;
	font-weight: 500;
	cursor:pointer;
	:hover {
		background: transparent;
		color: #e01efe;
	}

	${mediaBreakpointDown('xs')} {
		padding: 15px 20px;
		font-size: 14px;
	}
`;

const CTAButton = styled(HeroButton)`
	border-radius: 10px;
	font-size: 14px;
	font-weight: 600 !important;
	color: #fffffff6;
	padding: 15px 45px;

	${mediaBreakpointDown('xs')} {
		padding: 15px 35px;
		font-size: 13px;
	}
`;

const PostCTAComponent = ({ dnpUrl }) => {
	const [show, setShow] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const lowerSection = document.querySelector('#lower-section, [class*="LowerSection"]');
            
            if (lowerSection) {
                const lowerSectionTop = lowerSection.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                
                if (window.scrollY > 750 && lowerSectionTop > windowHeight) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            } else {
                if (window.scrollY > 750) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); 

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

	return (
		<PostCTA show={show}>
			<PostCTAContent>

				<div>
					<h2>
						Fight for your rights
					</h2>
					<p>
						<img src={aiIcon} alt="AI Icon" /> AI that fights for you
					</p>
				</div>


				{/* <Link to={dnpUrl}> */}
				<CTAButton
					onClick={() => {
						trackCustomEvent({
							category: "Entire page tracker",
							action: "click",
							label: "Get Started, Post Sticky",
						});
						trackCustomEvent({
							category: "Learning Center CTA Click",
							action: "click",
							label: "Get Started, Post Sticky",
						});
						document.location = dnpUrl
					}}
					className="smp-footer"
					aria-label="Get Started"
				>
					Sign up today
				</CTAButton>
				{/*	</Link>*/}
			</PostCTAContent>
		</PostCTA>
	);
};

export default React.memo(PostCTAComponent);
